var _rect, _title, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 19,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LAX-OrderNow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron",
    fillRule: "nonzero",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.655880467773443,9.276020052001954 L13.90446746777343,18.590291952001955 L9.276020467773435,18.590291952001955 L16.02743246777345,9.276020052001954 L9.276020467773435,-2.479980452108066e-7 L13.90446746777343,-2.479980452108066e-7 L20.655880467773443,9.276020052001954 zM4.647573467773441,-2.479980452108066e-7 L-5.32226550831183e-7,-2.479980452108066e-7 L6.827915467773437,9.276020052001954 L0.07650346777344907,18.532914552001955 L4.724076467773443,18.532914552001955 L11.398985467773429,9.276020052001954 L4.647573467773441,-2.479980452108066e-7 z",
    id: "Shape",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBlack);
export default __webpack_public_path__ + "static/media/chevron-black.f9c9724e5efcf5c3a897045f9f7f0574.svg";
export { ForwardRef as ReactComponent };